export enum PHoverVariant {
  STAND_ALONE = 'stand-alone',
  FOR_TABLE = 'for-table',
}
